import {
  getTooltipArrowComponent,
  getTooltipSheetComponent,
  // getBarSeriesPointComponent,
  // getScatterSeriesPointComponent,
  getValueAxisGridComponent,
  getValueAxisLabelComponent,
} from 'globals/graph-utils';
import { grey } from 'globals/colors';
import { Theme, withStyles } from '@material-ui/core';
import { Tooltip } from '@devexpress/dx-react-chart-material-ui';

// export const BarSeriesPointComponent = getBarSeriesPointComponent({
//   rx: 7,
//   ry: 7,
//   maxBarWidth: 12,
// });
// export const ScatterSeriesPointComponent = getScatterSeriesPointComponent();

export const ValueAxisLabelComponent = getValueAxisLabelComponent({
  color: grey.V3,
});
export const ArgumentAxisLabelComponent = getValueAxisLabelComponent({
  color: grey.V3,
});
export const ValueAxisGridComponent = getValueAxisGridComponent({
  strokeColor: grey.V4,
  strokeDasharray: [5, 5],
});

export const TooltipSheetComponent = getTooltipSheetComponent();
export const TooltipArrowComponent = getTooltipArrowComponent();

export const TooltipOverlay = withStyles(({ palette }: Theme) => ({
  'popper-top': {
    '& div::after': {
      background: palette.common.black,
    },
  },
}))(Tooltip.Overlay);
